import { Selector, createSelector } from '@ngrx/store';

import * as RouterStoreSelectors from './router.selector';
import * as LocationRouterSelectors from './locations-router.selector';

import { InstalledApplicationsStoreSelectors } from '../installed-applications';

export const selectBundleId: Selector<object, string> = RouterStoreSelectors.selectRouterParam('bundleId');

export const selectDistinctBundleIdentifiersForLocation: Selector<object, string[]> = createSelector(
  LocationRouterSelectors.selectLocationId,
  InstalledApplicationsStoreSelectors.selectAllInstalledApplications,
  (locationId, installedApplications) => {
    return Array.from(
      new Set(
        installedApplications
          .filter((app) => !locationId || app.locationId === locationId)
          .map((app) => app.bundleIdentifier)
      )
    );
  }
);

export const selectCurrentInstalledApplications = createSelector(
  LocationRouterSelectors.selectLocationId,
  selectBundleId,
  InstalledApplicationsStoreSelectors.selectAllInstalledApplications,
  (locationId, bundleId, installedApplications) => {
    const appStats: Record<string, Record<string, Record<string, number>>> = {};

    const sourceApps = installedApplications.filter(
      (app) => (!locationId || app.locationId === locationId) && (!bundleId || app.bundleIdentifier === bundleId)
    );

    for (const app of sourceApps) {
      if (appStats[app.locationId] !== undefined) {
        appStats[app.locationId] = {};
      }

      if (appStats[app.locationId][app.bundleIdentifier] !== undefined) {
        appStats[app.locationId][app.bundleIdentifier] = {};
      }

      if (appStats[app.locationId][app.bundleIdentifier][app.bundleVersion] !== undefined) {
        appStats[app.locationId][app.bundleIdentifier][app.bundleVersion] = 1;
      } else {
        appStats[app.locationId][app.bundleIdentifier][app.bundleVersion] += 1;
      }
    }

    return appStats;
  }
);
